import React from "react";
import OrderTaskForm from "./OrderTaskForm";

// Tarea «Reprogramar entrega» (actor DESPACHO) — FORMCODE ELREP
const CONFIG = {
  stage: 1,
  title: "Reprogramar entrega",
  intro: "La entrega a domicilio no se pudo completar.",
  sections: ["pedido", "productos", "montos", "cliente", "entrega", "facturacion"],
  noteLabel: "Motivo / nueva fecha acordada",
  checklist: [
    "Coordina con el cliente una nueva fecha u horario.",
    "Si ya no quiere el pedido, cancélalo.",
  ],
  optionHints: {
    "Reprogramar entrega": "Vuelve a Entregar a domicilio.",
    "Cancelar pedido": "Termina el flujo sin entrega.",
  },
};

export default function ElevaxReprogramarEntrega(props) {
  return <OrderTaskForm {...props} config={CONFIG} />;
}
